/**
 * TYPES
 */
import {_aggregates} from 'src/aggregates/index.d';
import {ICommand} from 'src/aggregates/index.d';
import {IUpdateTagPatch} from 'src/aggregates/tags/mutations.d';


/**
 * EXPORTS
 */
export enum _names
{
    TAGS_CREATE = 'TAGS_CREATE',
    TAGS_LOAD = 'TAGS_LOAD',
    TAGS_ERROR_RESET = 'TAGS_ERROR_RESET',
    TAGS_UPDATE = 'TAGS_UPDATE',
}

export interface ITagsCreate extends ICommand
{
    _aggregate: _aggregates.TAGS;
    _name: _names.TAGS_CREATE;
    color: string;
    name: string;
}

export interface ITagsLoad extends ICommand
{
    _aggregate: _aggregates.TAGS;
    _name: _names.TAGS_LOAD;
}

export interface ITagsErrorReset extends ICommand
{
    _aggregate: _aggregates.TAGS;
    _name: _names.TAGS_ERROR_RESET;
}

export interface ITagsUpdate extends ICommand
{
    _aggregate: _aggregates.TAGS;
    _name: _names.TAGS_UPDATE;
    color: string;
    tag: IUpdateTagPatch;
}
